import { Button } from "$components/button/button";
import { PlusIconBorderless } from "$components/icons";
import React from "react";
import { FormattedMessage } from "react-intl";

interface AddInvestigationButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

const AddInvestigationButton = ({
  onClick: handleClick,
}: AddInvestigationButtonProps): React.ReactElement => {
  return (
    <Button
      variant="contained"
      color="secondary"
      onClick={handleClick}
      data-testid="add-investigations-button"
      startIcon={<PlusIconBorderless color="primary" />}
    >
      <FormattedMessage
        id="investigations.initialForm.new.title"
        defaultMessage="Investigation"
      />
    </Button>
  );
};

export default AddInvestigationButton;
